import * as React from 'react';
import { Row, Col, Button, DropdownButton, Dropdown } from 'react-bootstrap';
import autobind from 'autobind-decorator';

interface IMarkerFormProps {
    cancelCallback: any;
    saveCallback: any;
}

interface IMarkerFormState {
    type: string;
    isModule: boolean;
    title: string;
}

export default class MarkerForm extends React.Component<IMarkerFormProps, IMarkerFormState> {
    constructor(props: IMarkerFormProps) {
        super(props);

        this.state = {
            type: 'S',
            isModule: false,
            title: undefined
        }
    }

    @autobind
    handleTypeSelect(eventKey, event) {
        this.setState({
            type: eventKey
        })
    }

    @autobind
    handleQuizSelect(eventKey, event) {
        this.setState({
            isModule: eventKey === '1'
        })
    }

    @autobind
    onSave() {
        this.props.saveCallback(this.state.title,this.state.type);
    }

    public render() {
        return (
            <Row>
                <Col sm={{ span: 1 }}>
                    <Button variant='danger' onClick={this.props.cancelCallback}>
                        Cancel
                    </Button>
                </Col>
                <Col sm={{ span: 3 }} style={{marginLeft:'2%'}}>
                    <DropdownButton
                        variant="light"
                        title={this.state.type === 'Q' ? 'Quiz Marker' : 'Section Marker'}
                        id={`dropdown-button-drop-right-2`}
                        onSelect={this.handleTypeSelect}
                    >
                        <Dropdown.Item eventKey="S">Section Marker</Dropdown.Item>
                        <Dropdown.Item eventKey="Q">Quiz Marker</Dropdown.Item>
                    </DropdownButton>
                </Col>
                <Col sm={{ span: 3 }} >
                    <input type='text'
                        style={{width:'99%'}}
                        placeholder='Marker Title'
                        onChange={(e) => this.setState({ title: e.target.value })}
                    />
                </Col>
                <Col sm={{ span: 2 }} style={{marginLeft:'-4%'}}>
                    <DropdownButton
                        variant="light"
                        title={this.state.isModule ? 'Add Module' : 'Add Question'}
                        id={`dropdown-button-drop-right-3`}
                        onSelect={this.handleQuizSelect}
                    >
                        <Dropdown.Item eventKey='0'>Add Question</Dropdown.Item>
                        <Dropdown.Item eventKey='1'>Add Module</Dropdown.Item>
                    </DropdownButton>
                </Col>
                <Col sm={{ span: 3 }}>
                    <Button style={{float:'right'}} variant='success' onClick={this.onSave}>
                        Add
                    </Button>
                </Col>
            </Row>
        );
    }
}
